import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
    byEmployeeId: {},
    queryRange: null,
};

const breakTasksSlice = createSlice({
    name: "breakTasks",
    initialState,
    reducers: {
        setEmpBreakSummary: (state, action) => {
            state.byEmployeeId = action.payload;
        },
        setBreakTaskQueryRange: (state, action) => {
            state.queryRange = action.payload;
        },
        resetBreakTasks: (state) => {
            state.byEmployeeId = {};
            state.queryRange = null;
        },
    },
});

export const { setEmpBreakSummary, setBreakTaskQueryRange, resetBreakTasks } = breakTasksSlice.actions;

// Selectors
// export const selectEmpBreakSummary = (state) => state.breakTasks?.byEmployeeId;
// export const selectEmpBreakSummaryByEmployeeId = (employeeId) => createSelector([selectEmpBreakSummary], (map) => map?.[employeeId] ?? null);
export const selectBreakTaskQueryRange = (state) => state.breakTasks?.queryRange;
export default breakTasksSlice.reducer;
